// components/CreateGuestListModal.js
import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiX, FiCheck } from 'react-icons/fi';
import supabase from '../services/supabase';
import { useAuth } from '../services/auth';
import '../styles/Modals.scss';

const CreateGuestListModal = ({ isOpen, onClose, onCreated }) => {
  const { user } = useAuth();
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [creating, setCreating] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      alert('Please enter a name for the guest list');
      return;
    }

    try {
      setCreating(true);

      const { data, error } = await supabase
        .from('guest_lists')
        .insert({
          user_id: user.id,
          name: name.trim(),
          description: description.trim() || null,
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
        })
        .select()
        .single();

      if (error) throw error;

      setName('');
      setDescription('');
      onCreated(data);
    } catch (error) {
      console.error('Error creating guest list:', error);
      alert('Failed to create guest list');
    } finally {
      setCreating(false);
    }
  };

  const handleClose = () => {
    setName('');
    setDescription('');
    onClose();
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="modal-overlay" onClick={handleClose}>
          <motion.div
            className="modal-content create-guest-list-modal"
            initial={{ opacity: 0, scale: 0.9, y: 50 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 50 }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="modal-header">
              <h3>Create Guest List</h3>
              <button className="close-btn" onClick={handleClose}>
                <FiX />
              </button>
            </div>

            {/* Form */}
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="form-group">
                  <label htmlFor="name">Name *</label>
                  <input
                    id="name"
                    type="text"
                    className="form-input"
                    placeholder="e.g., College Friends, Family"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    maxLength={50}
                    autoFocus
                  />
                  <div className="char-count">{name.length}/50</div>
                </div>

                <div className="form-group">
                  <label htmlFor="description">Description (Optional)</label>
                  <textarea
                    id="description"
                    className="form-input textarea"
                    placeholder="Add a description..."
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    maxLength={200}
                    rows={4}
                  />
                  <div className="char-count">{description.length}/200</div>
                </div>
              </div>

              {/* Footer */}
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button 
                  type="submit" 
                  className="btn btn-primary" 
                  disabled={!name.trim() || creating}
                >
                  {creating ? (
                    <div className="spinner small"></div>
                  ) : (
                    <>
                      <FiCheck />
                      <span>Create Guest List</span>
                    </>
                  )}
                </button>
              </div>
            </form>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default CreateGuestListModal;